/**
 * @generated SignedSource<<9d4eb15248e36324a8089127b7c6f6d8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PaymentLinkComment_pixQrCode$data = {
  readonly comment: string | null | undefined;
  readonly " $fragmentType": "PaymentLinkComment_pixQrCode";
};
export type PaymentLinkComment_pixQrCode$key = {
  readonly " $data"?: PaymentLinkComment_pixQrCode$data;
  readonly " $fragmentSpreads": FragmentRefs<"PaymentLinkComment_pixQrCode">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PaymentLinkComment_pixQrCode",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "comment",
      "storageKey": null
    }
  ],
  "type": "PixQrCode",
  "abstractKey": null
};

(node as any).hash = "81f0f3981754ef31a9e6cb92d8046c48";

export default node;
